import * as openidClient from 'openid-client';
import axios from 'axios';

import config from '../config';
import { StorageKeys } from '../constants';

const {
  network: {
    apiKey,
    apiBaseUrl,
    oidc: { authority, clientId, redirectUri, postLogoutRedirectUri, scope },
  },
} = config;

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'X-API-Key': apiKey,
  },
});

const authClient = {
  // Start authorization with PKCE
  signinRedirect: async () => {
    const openidConfig = await openidClient.discovery(
      new URL(authority),
      clientId,
    );

    const codeVerifier = openidClient.randomPKCECodeVerifier();
    const codeChallenge =
      await openidClient.calculatePKCECodeChallenge(codeVerifier);
    const state = openidClient.randomState();

    sessionStorage.setItem(StorageKeys.PKCE_CODE_VERIFIER, codeVerifier);

    const authorizationUrl = openidClient.buildAuthorizationUrl(openidConfig, {
      redirect_uri: redirectUri,
      scope,
      code_challenge: codeChallenge,
      code_challenge_method: 'S256',
      state,
    });

    window.location.replace(authorizationUrl);
  },
  // Handle authorization callback
  signinCallback: async (code) => {
    const codeVerifier = sessionStorage.getItem(StorageKeys.PKCE_CODE_VERIFIER);
    const response = await apiClient.post('/auth/token', {
      code,
      redirect_uri: redirectUri,
      code_verifier: codeVerifier,
    });
    return response.data;
  },
  // Start refresh token grant
  signinSilent: async (refreshToken) => {
    const response = await apiClient.post('/auth/refresh', {
      refresh_token: refreshToken,
    });
    return response.data;
  },
  signoutRedirect: async (idToken) => {
    const openidConfig = await openidClient.discovery(
      new URL(authority),
      clientId,
    );

    const logoutUrl = openidClient.buildEndSessionUrl(openidConfig, {
      id_token_hint: idToken,
      post_logout_redirect_uri: postLogoutRedirectUri,
    });

    window.location.replace(logoutUrl);
  },
};

export default authClient;
